import coreStore from "./core-store";
import Axios from "axios"

const remoteResource = 'currency/api/v1/exchange-rates';

const store = coreStore.createCoreStore('exchangeRate', remoteResource);

store.actions.fetchValues = async ({}, {id}) => {
    return (await Axios.get(`${remoteResource}/${id}/values`)).data;
}

export default store;
